module.exports = __webpack_public_path__ + "static/media/NTRO-Logo-RGB.38f1d7ce.webp";